import { render, staticRenderFns } from "./real-estate.vue?vue&type=template&id=2a03d6e4&scoped=true&lang=pug"
import script from "./real-estate.vue?vue&type=script&lang=ts"
export * from "./real-estate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a03d6e4",
  null
  
)

export default component.exports